import WebGalleryAlbumFolderCard from './WebGalleryAlbumFolderCard';

export default WebGalleryAlbumFolderCard;
